<template>
  <tr>
    <td>{{ device.model }}</td>
    <td>{{ device.serial_number }}</td>
    <td>
      <status-title :status="device.status" type="device"></status-title>
    </td>
    <td>
      <span v-if="!hasCourse" class="text-danger small">
        {{ $t('src/components/table-rows/devicetablerow.4998') }}
      </span>
      <div v-else v-for="hospital in uniqueHospitals" :key="hospital.hospital_id">
        <router-link
          :to="{ path: '/courses', query: { hospital: hospital.hospital_id } }"
          class="text-primary small"
        >
          {{ hospital.hospital_name }}
        </router-link>
      </div>
    </td>
    <td>
      <div class="d-flex">
        <div v-if="device.last_used.last_date">
          <div>{{ formattedStartDate }}</div>
          <div class="text-center">
            <router-link :to="lastUsedLink" class="link-small link-underline">{{
              $t('button.goTo')
            }}</router-link>
          </div>
        </div>
      </div>
    </td>
    <td></td>
  </tr>
</template>

<script>
import StatusTitle from '@/components/StatusTitle.vue'
import { formatDate } from '@/mixins/format-date'
import { userRights } from '@/mixins/user-rights'

export default {
  name: 'DeviceAdminTableBody',
  mixins: [userRights, formatDate],
  components: {
    StatusTitle
  },
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasCourse() {
      return this.courses.length > 0
    },
    courses() {
      return this.device.course || []
    },
    uniqueHospitals() {
      const hospitals = new Map()
      this.courses.forEach(course => {
        if (!hospitals.has(course.hospital_id)) {
          hospitals.set(course.hospital_id, {
            hospital_name: course.hospital_name,
            hospital_id: course.hospital_id
          })
        }
      })
      return Array.from(hospitals.values())
    },
    formattedStartDate() {
      return this.device.last_used.last_date ? this.getFormattedDate(this.device.last_used.last_date) : ''
    },
    lastUsedLink() {
      return {
        name: this.device.last_used.entity_type,
        params: { id: this.device.last_used.entity_id },
        query: { hospital: 1 }
      }
    }
  },
  methods: {
    editDevice() {
      this.$emit('edit:device', this.device)
    },
    resetDevice() {
      this.$emit('reset:device', this.device)
    }
  }
}
</script>
